import PropTypes from 'prop-types';

import { useMediaQuery } from '@mui/material';

const MHidden = ({ width, children }) => {
  const breakpoint = width.substring(0, 2);

  const hiddenUp = useMediaQuery((theme) => theme.breakpoints.up(breakpoint));
  const hiddenDown = useMediaQuery((theme) => theme.breakpoints.down(breakpoint));

  if (width.includes('Down')) {
    return hiddenDown ? null : children;
  }

  if (width.includes('Up')) {
    return hiddenUp ? null : children;
  }
};

MHidden.propTypes = {
  children: PropTypes.node,
  width: PropTypes.oneOf([
    'xsDown',
    'srDown',
    'sdDown',
    'smDown',
    'mdDown',
    'lgDown',
    'xlDown',
    'gtDown',
    'xsUp',
    'srUp',
    'sdUp',
    'smUp',
    'mdUp',
    'lgUp',
    'xlUp',
    'gtUp'
  ]).isRequired
};

export default MHidden;
